import { createApi } from '@reduxjs/toolkit/query/react';

import { VersionDto } from '../common/dto/common.dto';
import { baseQueryWithoutAccess } from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;

export const versionApi = createApi({
  reducerPath: 'versionApi',
  baseQuery: baseQueryWithoutAccess(`${API_URI}`),
  endpoints: (builder) => ({
    getVersion: builder.query<VersionDto, void>({
      query: () => `/app/version`,
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useLazyGetVersionQuery } = versionApi;
